module.exports = __webpack_public_path__ + "img/bluebook-2015.4b474f25.jpg";